import { render, staticRenderFns } from "./contas-a-receber.vue?vue&type=template&id=b86e7738&"
import script from "./contas-a-receber.vue?vue&type=script&lang=js&"
export * from "./contas-a-receber.vue?vue&type=script&lang=js&"
import style0 from "./contas-a-receber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports